import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';

import { HugeiconsIconComponent } from '@hugeicons/angular';
import { MoreVerticalIcon } from '@hugeicons/core-free-icons';

export interface ActionItem {
    label: string;
    icon?: any;
    action: string;
    variant?: 'default' | 'danger';
}

@Component({
    selector: 'app-action-dropdown',
    standalone: true,
    imports: [HugeiconsIconComponent],
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss'
})
export class DropdownComponent {
    @Input() actions: ActionItem[] = [];
    @Input() triggerIcon: any = MoreVerticalIcon;
    @Output() actionClick = new EventEmitter<string>();

    isOpen = false;

    constructor(private elementRef: ElementRef) { }

    toggle() {
        this.isOpen = !this.isOpen;
    }

    handleAction(action: string) {
        this.actionClick.emit(action);
        this.isOpen = false;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }
}
